import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form/bootstrap';
import ReactHookFormRoofSelect from 'common/components/segment/ReactHookFormRoofSelect';
import RenderInputsPerSystem from 'common/components/segment/RenderInputsPerSystem';
import { arraytoDictionary } from 'common/utils/helpers';

import createProposalModal from '../../../../createProposalModal';

const TabRooftop = ({
    control,
    fetchSystemTypes,
    google,
    roofTypes,
    setValue,
    systemTypes,
}) => {
    const { t } = useTranslation();
    const { getRoofTypesOptions, getSystemTypesOptions } =
        createProposalModal.helpers;

    const [system_uid, type_application] = useWatch({
        control,
        name: ['system_uid', 'type_application'],
    });

    const systemsDictionary = arraytoDictionary(systemTypes, 'id');

    const onChangeSystem = (e) => {
        const system = e.target.value;
        const newSystemUid = systemsDictionary[system]?.uniqueid || '';
        setValue('system_uid', newSystemUid);
    };

    useEffect(() => {
        fetchSystemTypes(type_application);
    }, [type_application]);

    return (
        <>
            <ReactHookFormInput
                control={control}
                fullWidth
                label={t('Name')}
                name="name"
            />

            <ReactHookFormRoofSelect
                control={control}
                disabled
                label={t('Roof type')}
                name="type_application"
                options={getRoofTypesOptions(roofTypes)}
            />

            <ReactHookFormSelect
                control={control}
                disabled
                label={t('System type')}
                name="system"
                onChange={onChangeSystem}
                options={getSystemTypesOptions(systemTypes)}
            />

            <RenderInputsPerSystem
                control={control}
                google={google}
                isNew={false}
                systemUid={system_uid}
            />
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    roofTypes: createProposalModal.selectors.getRoofTypesData,
    systemTypes: createProposalModal.selectors.getSystemTypesData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSystemTypes: (type) =>
        dispatch(createProposalModal.actions.fetchSystemTypes(type)),
});

TabRooftop.propTypes = {
    control: PropTypes.object,
    fetchSystemTypes: PropTypes.func,
    google: PropTypes.object,
    roofTypes: PropTypes.array,
    setValue: PropTypes.func,
    systemTypes: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(TabRooftop);
